import { render } from "./component-adress-type-el-area.vue?vue&type=template&id=b267029a"
import script from "./component-adress-type-el-area.vue?vue&type=script&setup=true&lang=js"
export * from "./component-adress-type-el-area.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/counteragents/counteragent-version-card/components/component-adress-type-el-area.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b267029a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b267029a', __exports__)) {
    api.reload('b267029a', __exports__)
  }
  
  module.hot.accept("./component-adress-type-el-area.vue?vue&type=template&id=b267029a", () => {
    api.rerender('b267029a', render)
  })

}


export default __exports__